import React from "react";

const Loader = () => {
  return <h6 className="loader">Loading...</h6>;
};

export default Loader;
